import { usePage } from '@inertiajs/react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useNotifications } from '@/hooks/usePushNotifications';
import type { SharedProps } from '@/types';

export default function NotificationBanner() {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const { permission, isSupported, isLoading, requestPermission } = useNotifications();
  const { current_account: currentAccount } = usePage<SharedProps>().props;
  const [isGranted, setIsGranted] = useState(false);

  const shouldShowBanner = !!currentAccount && isSupported && permission === 'default' && !isGranted;

  const handleEnableNotifications = async () => {
    const { permission: result, subscribed } = await requestPermission();

    if (subscribed) {
      setIsGranted(true);
    } else if (result !== 'default') {
      toast.error(t('notifications.enable_error'));
    }
  };

  if (!shouldShowBanner) return null;

  return (
    <Alert variant='filled' color='brand' radius={0} p='xs'>
      <Group justify='space-between' align='center' wrap='nowrap'>
        <Text fz='sm'>{t('notifications.banner_message')}</Text>
        <Button
          size={isMobile ? 'xs' : 'sm'}
          variant='white'
          color='brand'
          onClick={handleEnableNotifications}
          loading={isLoading}
          leftSection={<IconBell size={isMobile ? 14 : 16} />}
          style={{ flexShrink: 0 }}
        >
          {t('notifications.enable')}
        </Button>
      </Group>
    </Alert>
  );
}
